import React from 'react';
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

export default function WelcomeSection({ userName }) {
  return (
    <section 
      className={cn(
        "relative w-full bg-cover bg-center bg-no-repeat",
        "min-h-[400px] flex items-center justify-center",
        "before:absolute before:inset-0 before:bg-black/40 before:z-0"
      )}
      style={{ backgroundImage: "url('/Rectangle3842.png')" }}
    >
      <Container className="relative z-10">
        <Stack spacing="md" align="center" className="text-center text-white">
          <Heading level="h1" className="text-4xl md:text-5xl font-bold">
            Hello, {userName}
          </Heading>
          <Text size="lg" className="max-w-2xl text-white/90">
            We're thrilled to have you here. Dive into the AI Evaluator platform and explore tools designed to help you excel. Let's redefine success together
          </Text>
        </Stack>
      </Container>
    </section>
  );
}